// extracted by mini-css-extract-plugin
module.exports = {"w5qey2":"w5qey2","c1lywb4d":"c1lywb4d","bnak8zc":"bnak8zc"};